import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import useFlash from "go-alert/AlertMessage";
import { ReactComponent as ActionSuccessSvg } from "../../../../../../../images/svg/check-solid.svg";
import { OrderContext } from "../../../contexts/OrderContext";

export const TipPaymentMessage = () => {
	const { t } = useTranslation();
	const { search } = useLocation();
	const urlSearchParams = new URLSearchParams(search);
	const transactionStatus = urlSearchParams.get("transactionStatus");
	const { addFlash } = useFlash();
	const { alreadyGivenTip } = useContext(OrderContext);

	useEffect(() => {
		if (transactionStatus === "fail") {
			addFlash({
				type: "danger",
				msg: "payment_failed",
			});
		}
	}, [transactionStatus, addFlash, t]);

	if (transactionStatus === "success" || (alreadyGivenTip && alreadyGivenTip > 0)) {
		return (
			<div className="order-tips-success-message" data-testid="order-tips-successful-message">
				<ActionSuccessSvg />
				<h2>{`${t("modules.e_order.field.tip_success.title")}!`}</h2>
			</div>
		);
	}

	return null;
};
